<template>
  <div :class="$style.root">
    <CommonBreadcrumbs :breadcrumbs="breadcrumbs" :class="$style.breadcrumbs" />
    <div :class="$style.container">
      <div :class="$style.main_icon_box">
        <AtomsConsumerImage src="/images/mypage/mile/tential-club.svg" />
      </div>
      <div :class="$style.desc_section">
        <h2>コンディショニングを日常へ。</h2>
        <div v-if="!isSigned" :class="$style.btn_box">
          <MoleculesConsumerButtonWithArrowRight
            block
            variant="primary"
            @click="() => router.push('/sign_in?next=/guide/tential_club')"
          >
            新規会員登録・ログインはこちら</MoleculesConsumerButtonWithArrowRight
          >
        </div>
        <div :class="$style.sub_heading_box">
          <h3>マイルを貯めて次のステージへ。</h3>
          <p
            >TENTIALマイルはお買い物やアクションによって貯めることができ、1年間（毎年4/1~翌3/31）に獲得したマイルがお客様の会員ステージに反映されます。ステージが上がるとよりお得にマイルを獲得できたり、限定の特典を手に入れることができます。また貯めたマイルはクーポンをはじめとする特典への交換に使うことができます。</p
          >
        </div>
        <div :class="$style.mile_flow">
          <div :class="$style.flex">
            <AtomsConsumerImage src="/images/mypage/mile/smart-phone.svg" />
            <AtomsConsumerImage src="/images/mypage/mile/home.svg" />
          </div>
          <div :class="$style.arrow">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" stroke="#BBCBE1" stroke-width="5" transform="rotate(270 25 25)">
                <line x1="40" y1="25" x2="10" y2="25" />
                <polyline points="20,15 10,25 20,35" />
              </g>
            </svg>
          </div>
          <h4>ご購入やアクションに応じて<br />マイルが貯まります！</h4>
          <div :class="$style.arrow_box">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" stroke="#BBCBE1" stroke-width="5" transform="rotate(-45 25 25)">
                <line x1="40" y1="25" x2="10" y2="25" />
                <polyline points="20,15 10,25 20,35" />
              </g>
            </svg>

            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" stroke="#BBCBE1" stroke-width="5" transform="rotate(45 25 25)">
                <line x1="10" y1="25" x2="40" y2="25" />
                <polyline points="30,15 40,25 30,35" />
              </g>
            </svg>
          </div>
          <div :class="$style.flex">
            <div v-for="card of cardList" :key="card.title" :class="$style.card">
              <h5>{{ card.title }}</h5>
              <p v-html="card.description" />
              <div :class="$style.icon">
                <AtomsConsumerImage :src="card.icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.ribbon_icon_box">
        <AtomsConsumerImage src="/images/mypage/mile/ribbon.svg" />
      </div>
      <ul id="tabs" :class="$style.tab_box">
        <li :class="{ [$style.active]: '会員ステージ' === currentTab }" @click="setTab('会員ステージ')"
          >会員<br :class="$style.sp_only" />ステージ</li
        >
        <li :class="{ [$style.active]: 'マイルを貯める' === currentTab }" @click="setTab('マイルを貯める')"
          >マイルを<br :class="$style.sp_only" />貯める</li
        >
        <li :class="{ [$style.active]: 'マイルを交換' === currentTab }" @click="setTab('マイルを交換')"
          >マイルを<br :class="$style.sp_only" />交換</li
        >
        <li :class="{ [$style.active]: '特典' === currentTab }" @click="setTab('特典')">特典</li>
      </ul>
      <GuideStage v-if="currentTab === '会員ステージ'" />
      <GuideAction v-else-if="currentTab === 'マイルを貯める'" :mileage-set="site.mileage_set" />
      <GuideExchange v-else-if="currentTab === 'マイルを交換'" />
      <GuideReward v-else-if="currentTab === '特典'" />
      <div :class="$style.btn_box">
        <AtomsConsumerLink :url="FAQ_URL_TENTIAL_CLUB">
          <MoleculesConsumerButtonWithArrowRight block variant="primary">
            よくある質問はこちら
          </MoleculesConsumerButtonWithArrowRight>
        </AtomsConsumerLink>
      </div>
    </div>
    <ul :class="$style.bottom_cart_navigation">
      <li v-for="tab of tabs" :key="tab" @click.prevent="clickContents(tab)"> {{ tab }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { FAQ_URL_TENTIAL_CLUB } from "@tential/ec-gql-schema/const/karakuri"
import { EventHandler } from "~/types/events"
import { useCustomMeta } from "~/composables/meta"
import { useStore } from "~/stores"

type Breadcrumb = {
  title?: string
  url?: string
}

const breadcrumbs: Breadcrumb[] = [
  {
    title: "トップ",
    url: "/",
  },
  {
    title: "TENTIAL会員とは",
    url: "/guide/tential_club",
  },
]

type Card = {
  title: string
  description: string
  icon: string
}

const cardList: Card[] = [
  {
    title: "マイルを特典に交換",
    description: "マイルを交換して<br/>クーポンなどの特典と交換",
    icon: "/images/mypage/mile/mile.svg",
  },
  {
    title: "ためてステージアップ",
    description: "年間の累計獲得マイルで<br/>次のステージに",
    icon: "/images/mypage/mile/multi-mile.svg",
  },
]

const tabs = ["会員ステージ", "マイルを貯める", "マイルを交換", "特典"]
const currentTab = ref<string>("会員ステージ")
const customMeta = useCustomMeta()
const config = useRuntimeConfig()
const store = useStore()
const BASE_URL = config.public.BASE_URL

const setTab = (tab: "会員ステージ" | "マイルを貯める" | "マイルを交換" | "特典"): void => {
  currentTab.value = tab
}
const router = useRouter()

const isSigned = computed(() => {
  return store.user.isSigned
})

const site = await useSite().fetchSiteFindOne()

const clickContents: EventHandler = (tab: "会員ステージ" | "マイルを貯める" | "マイルを交換" | "特典"): void => {
  const targetEl = document.querySelector<HTMLElement>(`[id='tabs']`)
  currentTab.value = tab
  if (targetEl) {
    targetEl.scrollIntoView({ behavior: "smooth" })
  }
}

useHead(
  customMeta.fetch({
    title: "TENTIAL Club - TENTIAL会員プログラム",
    description:
      "TENTIAL Clubは、お客様ご自身や大切な方のコンディショニングを支える会員プログラムです。ご購入やアクションでマイルを貯めると、様々な特典を受けるとことができます。",
    image: `${BASE_URL}/images/site/tential-club-ogp.png`,
  }),
)
</script>

<style scoped module lang="scss">
.root {
  position: relative;
  .breadcrumbs {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    @include md {
      margin-top: 1.25rem;
      margin-bottom: 1.25rem;
    }
  }
  .container {
    @include container-sm;
    @include md {
      padding: 0 1rem;
      margin-bottom: 3rem;
    }

    .btn_box {
      padding: 0 1rem;
    }

    .main_icon_box {
      background-color: #f5f7fa;
      padding: 80px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 38px;
      > img {
        max-width: 283px;
        width: 100%;
      }
    }

    .desc_section {
      padding: 0 1rem;
      .btn_box {
        padding-bottom: 42px;
        border-bottom: 1px solid $primary-20;
        margin-bottom: 80px;
      }

      h2 {
        @include main-font;
        font-size: $font-size-20;
        color: $primary;
        margin-bottom: 32px;
        text-align: center;
      }

      h3 {
        @include main-font;
        font-size: $font-size-20;
        color: $primary;
        margin-bottom: 18px;
      }

      h4 {
        @include main-font;
        font-size: $font-size-15;
        color: $primary;
        text-align: center;
      }
      h5 {
        color: $primary;
        font-size: $font-size-15;
        margin-bottom: 0.5rem;
      }
      p {
        font-size: $font-size-13;
        line-height: 2;
        @include md {
          font-size: $font-size-15;
        }
      }

      .sub_heading_box {
        margin-bottom: 30px;
      }
      .mile_flow {
        margin-bottom: 44px;

        .flex {
          display: flex;
          justify-content: center;
          align-items: baseline;
          gap: 0.75rem;
          margin-bottom: 0.5rem;
        }

        .arrow {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
        }

        .arrow_box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          max-width: 200px;
          margin: auto;
        }

        .card {
          h5,
          p,
          .icon {
            text-align: center;
          }
        }
      }
    }
    .ribbon_icon_box {
      margin-bottom: 22px;
      > img {
        width: 100%;
      }
    }

    .tab_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $primary-20;
      margin-bottom: 60px;
      li {
        width: 25%;
        list-style: none;
        padding: 0.5rem 1rem;
        cursor: pointer;
        border-bottom: 3px solid transparent;
        font-size: $font-size-13;
        text-align: center;
        @include sub-font;

        &.active {
          border-bottom: 3px solid $primary;
        }

        &:hover:not(.active) {
          border-bottom: 3px solid $primary-20;
        }

        &:last-child {
          padding-bottom: 2rem;
          @include md {
            padding-bottom: 0.5rem;
          }
        }

        .sp_only {
          @include md {
            display: none;
          }
        }
      }
    }
  }
  .bottom_cart_navigation {
    display: flex;
    position: fixed;
    bottom: 0;
    z-index: 9;
    width: 100%;
    background: $white;
    box-shadow: 0 0 3px 0 $black-20;
    list-style: none;
    justify-content: space-around;
    @include md {
      display: none;
    }
    li {
      text-align: center;
      padding: 1.5rem 0;
      font-size: $font-size-13;
      cursor: pointer;
      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
